<div id="promo-wrapper">
    <section id="promo" class="mt-4 mb-4">
        <div class="container dark">



            <div class="eyebrow" i18n>AlbCode CRM</div>
            <header>
                <h2 i18n>Ihr maßgeschneidertes CRM – einfach, effizient, individuell</h2>
            </header>

            <p class="lead" i18n>
                Das <strong>CRM-System von AlbCode</strong> bündelt Kundenverwaltung, Projekt- & Aufgabenmanagement,
                <strong>E-Mail-Integration</strong>, <strong>Teamkalender</strong> und <strong>Projektzeiterfassung</strong>. Mit der nativen
                <strong>Android-Kalender-App</strong> bleiben Termine auch unterwegs griffbereit.
            </p>

            <p i18n>
                Unser <strong>Custom CRM-System</strong> ist eine moderne, <strong>sichere Webanwendung</strong>, die von überall und mit unterschiedlichen Geräten genutzt werden
                kann – sei es Desktop, Laptop, Tablet oder Smartphone. Mit <strong>Angular-Frontend</strong> und <strong>Spring Boot-Backend</strong> vereint es Leistungsfähigkeit,
                Flexibilität und Benutzerfreundlichkeit.
            </p>

            <p i18n>Behalten Sie alles im Blick:</p>
            <ul>
                <li i18n><strong>Aufgabenmanagement:</strong> To-dos, Termine und Deadlines zentral und effizient verwalten.</li>
                <li i18n><strong>E-Mail-Integration:</strong> E-Mails empfangen, versenden und archivieren – direkt im CRM.</li>
                <li i18n><strong>Projektverwaltung:</strong> Projekte planen, verfolgen und steuern.</li>
                <li i18n><strong>Vorgangsverwaltung:</strong> Alle geschäftlichen Abläufe, Anfragen und Fälle transparent im Blick.</li>
                <li i18n><strong>Kontakte & Adressen:</strong> Kunden, Partner und Lieferanten zentral verwalten.</li>
                <li i18n><strong>Notizen & Dokumente:</strong> Informationen, Dateien und Anhänge strukturiert speichern.</li>
                <li i18n><strong>Kalender:</strong> Termine mit Teilnehmern, Einladungen, Erinnerungen und unterschiedlichen Ansichten organisieren.</li>
                <li i18n><strong>Projektzeiterfassung:</strong> Arbeitszeiten projektbezogen dokumentieren, auswerten und nach Abrechenbarkeit unterscheiden.</li>
                <li i18n><strong>Android-App:</strong> Den CRM-Kalender mobil nutzen und an anstehende Termine erinnert werden.</li>
                <li i18n><strong>Leistungsstarke Suche, Filter & Sortierung:</strong> Daten schnell finden – auch bei großen Datenmengen.</li>
            </ul>

            <p i18n>
                Das CRM ist übersichtlich, intuitiv bedienbar und passt sich individuell an Ihre Anforderungen an. Ideal für kleinere Unternehmen. Keine unnötigen Funktionen – nur
                das, was Sie wirklich brauchen.
            </p>

            <p i18n>
                Und das Beste: Wir nehmen <strong>gerne weitere Anpassungen</strong> vor – z. B. individuelle Reports, Schnittstellen oder branchenspezifische Abläufe, die Ihr Team
                noch produktiver machen.
            </p>

            <p i18n>
                Starten Sie jetzt mit einer <strong>sicheren, überall zugänglichen Lösung</strong>, die Ihre Prozesse vereinfacht, Zeit spart und Ihr Team optimal unterstützt.
            </p>

        </div>
    </section>
</div>


<div class="wrapper pb-3">
    <section class="container">
        <div class="row features justify-content-center">
            <main class="container">

                <!-- Feature-Visual -->
                <div class="image-wrapper mb-4">
                    <div class="image featured">
                        <img src="albcode_crm.png" alt="AlbCode CRM Dashboard" i18n-alt />
                    </div>
                </div>

                <!-- Kernnutzen -->
                <section class="section grid grid-3" aria-label="Kernnutzen" i18n-aria-label>
                    <article class="card mb-0">
                        <span class="badge" i18n>Kundenverwaltung</span>
                        <h3 i18n>Alle Daten zentral & sicher</h3>
                        <p i18n>Kontakte, Vorgänge, Dokumente und Notizen an einem Ort – durchsuchbar, nachvollziehbar und teamweit verfügbar, auf Desktop, Tablet oder Smartphone.</p>
                    </article>
                    <article class="card mb-0">
                        <span class="badge" i18n>Vorgänge, Projekte & Aufgaben</span>
                        <h3 i18n>Effiziente Teamarbeit</h3>
                        <p i18n>Projekte planen, Aufgaben zuordnen und Vorgänge verwalten – mit klaren Verantwortlichkeiten, Fristen und voller Transparenz für Ihr Team.</p>
                    </article>
                    <article class="card mb-0">
                        <span class="badge" i18n>E-Mail-Integration</span>
                        <h3 i18n>Postfach-Chaos ade</h3>
                        <p i18n>Zentraler Ein- & Ausgang, Aufgaben direkt aus E-Mails erstellen und automatische Zuordnung zu Kunden, Projekten oder Vorgängen – alles sicher im CRM.</p>
                    </article>
                </section>

                <section class="section grid grid-3" id="kalender-zeiterfassung-app" aria-label="Kalender, Zeiterfassung und Android-App" i18n-aria-label>
                    <article class="card mb-0">
                        <span class="badge" i18n>Teamkalender</span>
                        <h3 i18n>Termine gemeinsam organisieren</h3>
                        <p i18n>Planen Sie Besprechungen, Kundentermine und interne Aufgaben in Tages-, Wochen-, Monats- oder Agendaansicht. Teilnehmer, Einladungen, Status und
                            Erinnerungen bleiben direkt am Termin nachvollziehbar.</p>
                    </article>
                    <article class="card mb-0">
                        <span class="badge" i18n>Projektzeiterfassung</span>
                        <h3 i18n>Aufwand transparent auswerten</h3>
                        <p i18n>Erfassen Sie Arbeitszeiten direkt am Projekt – mit Datum, Zeitraum, Tätigkeit, Benutzer und Kennzeichnung als abrechenbar. Übersichten zeigen offene und
                            bereits abgeschlossene Zeiten.</p>
                    </article>
                    <article class="card mb-0">
                        <span class="badge" i18n>Native Android-App</span>
                        <h3 i18n>Der CRM-Kalender für unterwegs</h3>
                        <p i18n>Termine mobil ansehen, erstellen, bearbeiten, verschieben oder absagen. Die App verbindet sich sicher mit dem CRM, übernimmt das individuelle Branding und
                            erinnert direkt auf dem Android-Gerät.</p>
                    </article>
                </section>

                <!-- E-Mail & Globaler Posteingang -->
                <section class="section grid grid-2" id="email">
                    <div class="card">
                        <h3 i18n>E-Mails gehören ins CRM – nicht ins Postfach</h3>
                        <ul class="list">
                            <li i18n>Zentraler E-Mail-Ein- & Ausgang</li>
                            <li i18n>Aufgaben direkt aus E-Mails erstellen</li>
                            <li i18n>Automatische Zuordnung zu Kunden, Projekten oder Vorgängen</li>
                            <li i18n><strong>Globaler Posteingang</strong> für Webseitenkontakte & Social Media – getrennt von persönlichen Postfächern</li>
                        </ul>
                    </div>
                    <div class="card">
                        <h3 i18n>Mehr Überblick, weniger Suchaufwand</h3>
                        <p i18n>Alle Dokumente, Anhänge und Konversationen sind direkt im Vorgang verfügbar. Ihr Team spart täglich wertvolle Zeit.</p>
                        <p i18n>Ein Ort für alles, statt verstreuter Daten!</p>
                    </div>
                </section>

                <!-- Erweiterbarkeit & API -->
                <section class="section grid grid-2" id="integration">
                    <div class="card">
                        <span class="badge" i18n>Integration & API</span>
                        <h3 i18n>Flexibel & erweiterbar</h3>
                        <p i18n>Offene API für einfache Integration in bestehende Systeme, Automatisierungen und Erweiterungen. Kampagnenmodule oder Formulare lassen sich direkt mit
                            Kontakten verknüpfen – alles sicher und zuverlässig.</p>
                    </div>
                    <div class="card">
                        <span class="badge" i18n>Schneller Start & Support</span>
                        <h3 i18n>Produktiv in Tagen, nicht Monaten</h3>
                        <p i18n>Von Migration über Schulung bis zum laufenden Support – wir begleiten Ihr Team, damit Sie schnell von den Vorteilen profitieren. Einfach, effizient und
                            sofort einsatzbereit, überall verfügbar.</p>
                    </div>
                </section>

                <section class="section cta-section" aria-label="Demo anfordern" i18n-aria-label>
                    <div class="grid grid-1 mt-3">
                        <article class="card mb-0 d-flex flex-column justify-content-between">
                            <div>
                                <h2 i18n>Bereit für fokussiertes Arbeiten ohne ständige Tool-Wechsel?</h2>
                                <br>
                                <p i18n>Erleben Sie in einer kurzen, persönlichen Demo, wie das AlbCode CRM Ihre täglichen Abläufe vereinfacht. Wir zeigen Ihnen, wie Sie Kunden,
                                    Projekte, Aufgaben und Dokumente zentral verwalten, Zeit sparen und Ihr Team effizienter machen können – zugeschnitten auf Ihre individuellen
                                    Prozesse.</p>
                                <p i18n>Entdecken Sie, wie einfach es ist, alle wichtigen Informationen an einem Ort zu bündeln, E-Mails direkt im System zu verwalten und Vorgänge
                                    transparent nachzuverfolgen.</p>
                            </div>
                            <div class="cta-button-wrapper mt-3 mb-4">
                                <a class="glow-on-hover p-3" [routerLink]="['/contact']" i18n>Kontakt aufnehmen</a>
                            </div>
                        </article>
                    </div>
                </section>

                <!-- FAQ -->
                <section class="section" id="faq" aria-label="Häufige Fragen" i18n-aria-label>
                    <h2 i18n>FAQ – häufige Fragen</h2>
                    <div class="grid grid-2 mt-3">
                        <article class="card mb-0">
                            <h3 i18n>Ersetzt das AlbCode CRM Outlook oder Exchange?</h3>
                            <p i18n>Ja. Dank zentralem Ein- & Ausgang und globalem Posteingang werden E-Mails, Anhänge und Aufgaben direkt im CRM verwaltet – die separate Postfachsuche
                                entfällt.</p>
                        </article>
                        <article class="card mb-0">
                            <h3 i18n>Kann das CRM an unsere Systeme angebunden werden?</h3>
                            <p i18n>Ja. Das CRM ist API-basiert und lässt sich nahtlos integrieren – von ERP bis Drittsystem.</p>
                        </article>
                        <article class="card mb-0">
                            <h3 i18n>Gibt es ein Kampagnen-/Formularmodul?</h3>
                            <p i18n>Ein Kampagnenmodul mit Jotform-Anbindung ist in Entwicklung. Generische Formulare können ausgewertet und mit Kontakten verknüpft werden.</p>
                        </article>
                        <article class="card mb-0">
                            <h3 i18n>Hat das CRM einen Kalender und eine mobile App?</h3>
                            <p i18n>Ja. Der integrierte Teamkalender verwaltet Termine, Teilnehmer, Einladungen und Erinnerungen. Über die native Android-App steht der Kalender auch mobil
                                mit Tages-, Wochen-, Monats- und Agendaansicht zur Verfügung.</p>
                        </article>
                        <article class="card mb-0">
                            <h3 i18n>Wie funktioniert die Projektzeiterfassung?</h3>
                            <p i18n>Arbeitszeiten werden einem Projekt zugeordnet und mit Zeitraum, Dauer, Tätigkeit, Benutzer sowie Abrechenbarkeit dokumentiert. Eine zentrale Auswertung
                                schafft Transparenz für Projektsteuerung und Abrechnung.</p>
                        </article>
                        <article class="card mb-0">
                            <h3 i18n>Gibt es eine Lösung speziell für Immobilienverwaltungen?</h3>
                            <p i18n>Ja. <a [routerLink]="['/albcode/immobilienverwaltung']">ImmoConnect</a> erweitert die zentralen Arbeitsabläufe um Objekte, Wohneinheiten,
                                Schadensmanagement und immobilienbezogene Vorgänge.</p>
                        </article>
                    </div>
                </section>


            </main>
        </div>
    </section>
</div>
